import { useState } from "react";
import styles from "./EditScreenItemHeaderDiv.module.css";
import AddressPopupContent from "./AddressPopupContent/AddressPopupContent";
const EditScreenItemHeaderDiv = ({ title, subtitle, count, item }) => {
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const handleShowPopupAddress = () => {
    setShowAddressPopup((prev) => !prev);
  };
  console.log("title", title);
  return (
    <>
      <div className={styles.main_div}>
        <div className={styles.div1}>
          <div className={styles.div1sub1}>{title}</div>
          {subtitle !== "" && (
            <div className={styles.div1sub2}>
              <pre className={styles.div1sub2}>{subtitle}</pre>
            </div>
          )}
        </div>

        <div className={styles.div2}>
          <ion-icon className={styles.close_icon} name="close"></ion-icon>
        </div>
        <div className={styles.div3}>
          <pre className={styles.div3pre}>{count ? "個数   " + count : ""}</pre>
        </div>
        <div className={styles.div4}>
          配送先
          <button
            style={{
              color: "#000000c7",
            }}
            className={styles.address_button}
          >
            {item?.address_str}
          </button>
          <div
            className={styles.textUnderline}
            style={{ cursor: "pointer" }}
            onClick={handleShowPopupAddress}
          >
            お届け先を確認
          </div>
        </div>
      </div>
      {showAddressPopup && (
        <AddressPopupContent
          handleOpenAddressPopup={handleShowPopupAddress}
          item={item}
        />
      )}
    </>
  );
};

export default EditScreenItemHeaderDiv;
